<template>
  <div id="app">
    <!-- <Header   v-if="userInfo.yhid" @reloadZypg="reloadZypg" />
    <noHeader v-if="!userInfo.yhid"/>
    <keep-alive  v-if="$route.meta.keepAlive">
      <router-view v-if="$route.meta.keepAlive" :sxkmChangeReload="sxkmChangeReload"
      :sxkmChangeReloadYxcx="sxkmChangeReload" :sxkmChangeReloadYxtj="sxkmChangeReload"
      :sxkmChangeReloadScore="sxkmChangeReload" :sxkmChangeReloadMajor="sxkmChangeReload"
      :sxkmChangeReloadDateHome="sxkmChangeReload" />
    </keep-alive>
     v-if="RouteState && !$route.meta.keepAlive"
    <router-view v-if="RouteState && !$route.meta.keepAlive" :sxkmChangeReload="sxkmChangeReload"
    :sxkmChangeReloadYxcx="sxkmChangeReload" :sxkmChangeReloadYxtj="sxkmChangeReload"
    :sxkmChangeReloadScore="sxkmChangeReload" :sxkmChangeReloadMajor="sxkmChangeReload"
    :sxkmChangeReloadDateHome="sxkmChangeReload" />
    <Footer /> -->
    <router-view></router-view>
  </div>
</template>
<script>
import {mapState} from 'vuex';
// import $ from 'jquery';
export default {
  name: "App",
  data() {
    return {
      RouteState: true,
      sxkmChangeReload:'',
      gapTime:'',
      beforeUnloadTime:''
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.RouteState = false;
      this.$nextTick(() => {
        this.RouteState = true;
      });
    },
    reloadZypg(sxkmChangeLoad){
      if(sxkmChangeLoad){
        this.sxkmChangeReload=sxkmChangeLoad;
      }
    }
  },
  computed:{
    ...mapState(["userInfo"])
  },
  components: {
  }
};
</script>
<style>
#app{
    width: 100%;
    height: 100%;
    position:relative;
    /* background-color: #f5f5f5; */
    background-color: white;
    font-size: 14px;
}
*{
  padding: 0;
  margin: 0;
}
a{
  color: #333;
}


.quill-editor-wrap {
  width: 100%;
  box-sizing: border-box;
}

/* **************** 关键：映射宋体样式类，确保字体生效 **************** */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="simsun"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="simsun"]::before {
  content: "宋体";
  font-family: "宋体", SimSun;
}
.ql-font-simsun {
  font-family: "宋体", SimSun !important;
}

/* 映射其他字体（可选） */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="microsoftyahei"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="microsoftyahei"]::before {
  content: "微软雅黑";
  font-family: "微软雅黑", Microsoft YaHei;
}
.ql-font-microsoftyahei {
  font-family: "微软雅黑", Microsoft YaHei !important;
}

/* 强制设置编辑器默认字号16px，兜底保障 */
.ql-editor {
  font-size: 16px !important;
  line-height: 1.8;
  min-height: 400px;
}

/* 字号下拉框显示文本映射 */
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: attr(data-value);
}
</style>
